import { lazyRouteComponent, type RouteComponent } from "@tanstack/react-router"
import {
  createRootRoute,
  createRoute,
  createRouter,
  redirect,
} from "@tanstack/react-router"

import { AdminApp } from "./app/admin-app"

const rootRoute = createRootRoute({ component: AdminApp })
const emptyRoute = (path: "/login/" | "/mfa/" | "/forgot-password/" | "/reset-password/" | "/invite/") => createRoute({ getParentRoute: () => rootRoute, path, component: () => null })
const pageRoute = (path: "/dashboard" | "/applications/" | "/borrowers/" | "/loans/" | "/staff/" | "/audit/" | "/profile/" | "/loan-engine/" | "/customise/" | "/compliance/" | "/testimonials/" | "/blog/" | "/staff-activity/" | "/settings/", component: RouteComponent) => createRoute({ getParentRoute: () => rootRoute, path, component })
const applicationDetailRoute = createRoute({ getParentRoute: () => rootRoute, path: "/applications/$id", component: lazyRouteComponent(() => import("./routes/applications"), "ApplicationDetailRoute") })
const legacyKycRoute = createRoute({ getParentRoute: () => rootRoute, path: "/kyc", beforeLoad: () => { throw redirect({ to: "/applications" }) } })
const borrowerDetailRoute = createRoute({ getParentRoute: () => rootRoute, path: "/borrowers/$id", component: lazyRouteComponent(() => import("./routes/borrowers"), "BorrowerDetailRoute") })
const loanDetailRoute = createRoute({ getParentRoute: () => rootRoute, path: "/loans/$id", component: lazyRouteComponent(() => import("./routes/loans"), "LoanDetailRoute") })

const indexRoute = createRoute({ getParentRoute: () => rootRoute, path: "/", beforeLoad: () => { throw redirect({ to: "/dashboard" }) } })

const routeTree = rootRoute.addChildren([
  indexRoute,
  emptyRoute("/login/"),
  emptyRoute("/mfa/"),
  emptyRoute("/forgot-password/"),
  emptyRoute("/reset-password/"),
  emptyRoute("/invite/"),
  pageRoute("/dashboard", lazyRouteComponent(() => import("./routes/dashboard"), "DashboardRoute")),
  pageRoute("/applications/", lazyRouteComponent(() => import("./routes/applications"), "ApplicationsRoute")),
  applicationDetailRoute,
  legacyKycRoute,
  pageRoute("/borrowers/", lazyRouteComponent(() => import("./routes/borrowers"), "BorrowersRoute")),
  borrowerDetailRoute,
  pageRoute("/loans/", lazyRouteComponent(() => import("./routes/loans"), "LoansRoute")),
  loanDetailRoute,
  pageRoute("/staff/", lazyRouteComponent(() => import("./routes/staff"), "StaffRoute")),
  pageRoute("/audit/", lazyRouteComponent(() => import("./routes/audit"), "AuditRoute")),
  pageRoute("/profile/", lazyRouteComponent(() => import("./routes/profile"), "ProfileRoute")),
  pageRoute("/loan-engine/", lazyRouteComponent(() => import("./routes/loan-engine"), "LoanEngineRoute")),
  pageRoute("/customise/", lazyRouteComponent(() => import("./routes/customise"), "CustomiseRoute")),
  pageRoute("/compliance/", lazyRouteComponent(() => import("./routes/compliance"), "ComplianceRoute")),
  pageRoute("/testimonials/", lazyRouteComponent(() => import("./routes/testimonials"), "TestimonialsRoute")),
  pageRoute("/blog/", lazyRouteComponent(() => import("./routes/blog"), "BlogRoute")),
  pageRoute("/staff-activity/", lazyRouteComponent(() => import("./routes/staff-activity"), "StaffActivityRoute")),
  pageRoute("/settings/", lazyRouteComponent(() => import("./routes/settings"), "SettingsRoute")),
])

export const router = createRouter({ routeTree, defaultPreload: "intent", scrollRestoration: true })

declare module "@tanstack/react-router" {
  interface Register { router: typeof router }
}
